export const environment = {
  appVersion: require('../../package.json').version + '-stage',
  production: false,
  environmentName: 'STAGE',
  firebase: {
    apiKey: 'AIzaSyCiXUzV0Ed6evPsD8RseSpdc23Mkuf_fWU',
    authDomain: 'natmobile-1cee5.firebaseapp.com',
    databaseURL: 'https://natmobile-1cee5.firebaseio.com',
    projectId: 'natmobile-1cee5',
    storageBucket: 'natmobile-1cee5.appspot.com',
    messagingSenderId: '699894485472'
  },
  //apiUrl: 'http://tpslroutewsc.stage.nationex.com/',
  //apiUrl: 'http://api.fred.nationex.com/'
  apiUrl: 'https://apistage.nationex.com/',
  
  apiUrlV5: 'https://apicorestage.nationex.com/'
  
};
